import _defineProperty from "/Users/neelrao/Projects/citycraft/client/node_modules/@babel/runtime/helpers/esm/defineProperty";
import EDictionary from '../../external/EDictionary';
import copyProxy from '../protocol/copyProxy';
import getValue from '../protocol/getValue';
import setValue from '../protocol/setValue';

function WorldState(tick, timeBetweenSnapshots, snapshot, previousWorldState, config) {
  this.config = config;
  this.timeBetweenSnapshots = timeBetweenSnapshots;
  this.tick = tick;
  this.clientTick = snapshot.clientTick;
  this.raw = snapshot;
  this.processed = false;
  this.timestamp = snapshot.timestamp; // entity state

  this.entities = new EDictionary(config.ID_PROPERTY_NAME);
  this.noInterps = [];
  this.createEntities = [];
  this.updateEntities = [];
  this.deleteEntities = [];
  this.updateLookUp = {}; // localMessage state

  this.localMessages = []; // message state

  this.messages = []; // jsons

  this.jsons = [];
  this.ping = -1; //this.temporalOffset = -1

  this.init(snapshot, previousWorldState);
}

WorldState.prototype.containsUpdateFor = function (id, prop) {
  if (this.updateLookUp[id] && !isNaN(this.updateLookUp[id][prop])) {
    return true;
  }

  return false;
};

WorldState.prototype.init = function (snapshot, previousWorldState) {
  var _this = this;

  //console.log(snapshot)
  if (previousWorldState) {
    if (this.timestamp === -1) {
      this.timestamp = previousWorldState.timestamp + this.timeBetweenSnapshots;
    }

    previousWorldState.entities.forEach(function (entity) {
      var clone = copyProxy(entity, entity.protocol);
      clone.protocol = entity.protocol;

      _this.entities.add(clone);
    });
  }

  snapshot.engineMessages.forEach(function (message) {
    _this.noInterps = message.ids;
  });
  snapshot.createEntities.forEach(function (entity) {
    //this.createdEntityIds.push(entity.id)
    //console.log('yolo', entity)
    var clone = copyProxy(entity, entity.protocol);
    clone.protocol = entity.protocol; //console.log('yolo2', clone)

    _this.entities.add(clone);

    _this.createEntities.push(clone);
  });
  snapshot.localMessages.forEach(function (localMessage) {
    var clone = copyProxy(localMessage, localMessage.protocol);
    clone.protocol = localMessage.protocol;

    _this.localMessages.push(clone);
  });
  snapshot.messages.forEach(function (message) {
    var clone = copyProxy(message, message.protocol);
    clone.protocol = message.protocol;

    _this.messages.push(clone);
  });
  snapshot.jsons.forEach(function (json) {
    _this.jsons.push(JSON.parse(json));
  });
  snapshot.updateEntities.partial.forEach(function (update) {
    var _updateCopy;

    //console.log('YOLO', update)
    //this.updatedEntityIds.push(singleProp[this.config.ID_PROPERTY_NAME])
    var id = update[_this.config.ID_PROPERTY_NAME];

    var entity = _this.entities.get(id); //console.log('b4', entity.x)
    //entity[singleProp.prop] = singleProp.value


    setValue(entity, update.path, update.value); //console.log('after', entity.x)

    var updateCopy = (_updateCopy = {}, _defineProperty(_updateCopy, _this.config.ID_PROPERTY_NAME, id), _defineProperty(_updateCopy, "prop", update.prop), _defineProperty(_updateCopy, "path", update.path), _defineProperty(_updateCopy, "value", update.value), _updateCopy);

    _this.updateEntities.push(updateCopy);

    if (!_this.updateLookUp[id]) {
      _this.updateLookUp[id] = {};
    }

    _this.updateLookUp[id][updateCopy.prop] = updateCopy.value;
  });
  snapshot.updateEntities.optimized.forEach(function (batch) {
    //this.updatedEntityIds.push(batch[this.config.ID_PROPERTY_NAME])
    var entity = _this.entities.get(batch[_this.config.ID_PROPERTY_NAME]);

    batch.updates.forEach(function (update) {
      var _this$updateEntities$;

      if (update.isDelta) {
        var value = getValue(entity, update.path);
        setValue(entity, update.path, value + update.value); //entity[update.prop] += update.value
      } else {
        setValue(entity, update.path, update.value); //entity[update.prop] = update.value
      }

      _this.updateEntities.push((_this$updateEntities$ = {}, _defineProperty(_this$updateEntities$, _this.config.ID_PROPERTY_NAME, batch[_this.config.ID_PROPERTY_NAME]), _defineProperty(_this$updateEntities$, "prop", update.prop), _defineProperty(_this$updateEntities$, "path", update.path), _defineProperty(_this$updateEntities$, "value", entity[update.prop]), _this$updateEntities$));
    });
  });
  snapshot.deleteEntities.forEach(function (id) {
    _this.deleteEntities.push(id);

    _this.entities.removeById(id);
  });
};

export default WorldState;